/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeaveSettings } from './LeaveSettings';
import {
    LeaveSettingsFromJSON,
    LeaveSettingsFromJSONTyped,
    LeaveSettingsToJSON,
    LeaveSettingsToJSONTyped,
} from './LeaveSettings';

/**
 * 
 * @export
 * @interface UpdateLeaveSettingsResponse
 */
export interface UpdateLeaveSettingsResponse {
    /**
     * 
     * @type {LeaveSettings}
     * @memberof UpdateLeaveSettingsResponse
     */
    data: LeaveSettings;
}

/**
 * Check if a given object implements the UpdateLeaveSettingsResponse interface.
 */
export function instanceOfUpdateLeaveSettingsResponse(value: object): value is UpdateLeaveSettingsResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function UpdateLeaveSettingsResponseFromJSON(json: any): UpdateLeaveSettingsResponse {
    return UpdateLeaveSettingsResponseFromJSONTyped(json, false);
}

export function UpdateLeaveSettingsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLeaveSettingsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': LeaveSettingsFromJSON(json['data']),
    };
}

  export function UpdateLeaveSettingsResponseToJSON(json: any): UpdateLeaveSettingsResponse {
      return UpdateLeaveSettingsResponseToJSONTyped(json, false);
  }

  export function UpdateLeaveSettingsResponseToJSONTyped(value?: UpdateLeaveSettingsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': LeaveSettingsToJSON(value['data']),
    };
}

